var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookkeepers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 34,
    viewBox: "0 0 27 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 28.6667V7.33333C2 5.4665 2 4.53307 2.35813 3.82003C2.67313 3.19282 3.17578 2.68288 3.79403 2.36332C4.49688 2 5.41698 2 7.25714 2H19.7429C21.583 2 22.5032 2 23.206 2.36332C23.8242 2.68288 24.3269 3.19282 24.6419 3.82003C25 4.53307 25 5.4665 25 7.33333V25.3333H5.28571C3.47106 25.3333 2 26.8257 2 28.6667ZM2 28.6667C2 30.5077 3.47106 32 5.28571 32H25M23.3571 25.3333V32M18.4286 19.5C17.9627 17.5982 15.9331 16.1667 13.5 16.1667C11.0669 16.1667 9.03741 17.5982 8.57143 19.5M13.5 9.5H13.5164M15.1429 9.5C15.1429 10.4205 14.4074 11.1667 13.5 11.1667C12.5927 11.1667 11.8571 10.4205 11.8571 9.5C11.8571 8.57953 12.5927 7.83333 13.5 7.83333C14.4074 7.83333 15.1429 8.57953 15.1429 9.5Z",
    stroke: "#1E4387",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookkeepers);
export default __webpack_public_path__ + "static/media/bookkeepers.aeb223cd9f1b93daa5487967d92dcee5.svg";
export { ForwardRef as ReactComponent };